export const languageList = [
    {
        name: 'English',
        nameEng: 'english',
        code: 'eng'
    },
    {
        name: 'हिंदी',
        nameEng: 'Hindi',
        code: 'hin'
    },
    {
        name: 'বাংলা',
        nameEng: 'Bengali',
        code: 'Bengali'
    },
    {
        name: 'मराठी',
        nameEng: 'Marathi',
        code: 'Marathi'
    },
    {
        name: 'ਪੰਜਾਬੀ',
        nameEng: 'Punjabi',
        code: 'Punjabi'
    },
    {
        name: 'తెలుగు',
        nameEng: 'Telugu',
        code: 'Telugu'
    },
    {
        name: 'অসমীয়া',
        nameEng: 'Assamese',
        code: 'Assamese'
    },
    {
        name: 'ಕನ್ನಡ',
        nameEng: 'Kannada',
        code: 'Kannada'
    },
    {
        name: 'മലയാളം',
        nameEng: 'Malayalam',
        code: 'Malayalam'
    },
    {
        name: 'தமிழ்',
        nameEng: 'Tamil',
        code: 'Tamil'
    },
    {
        name: 'भोजपुरी',
        nameEng: 'Bhojpuri',
        code: 'Bhojpuri'
    },
    {
        name: 'اردو',
        nameEng: 'Urdu',
        code: 'Urdu'
    },
    {
        name: 'ଓଡ଼ିଆ',
        nameEng: 'Odiya',
        code: 'Odiya'
    },
    {
        name: 'ગુજરાતી',
        nameEng: 'Gujarati',
        code: 'Gujarati'
    },
    // {
    //     name: "ꯃꯩꯇꯩꯂꯣꯟ",
    //     nameEng: "Manipuri",
    //     code: "Manipuri"
    // }
]

export const LANGUAGES = [
    {
        label: "English",
        code: "english"
    },
    {
        label: "বাংলা",
        code: "bengali"
    },
    {
        label: "हिंदी",
        code: "hindi"
    },
    {
        label: "मराठी",
        code: "marathi"
    },
    {
        label: "தமிழ்",
        code: "tamil"
    },
    {
        label: "ಕನ್ನಡ",
        code: "kannada"
    },
    {
        label: "తెలుగు",
        code: "telugu"
    },
    {
        label: "ਪੰਜਾਬੀ",
        code: "punjabi"
    },
    {
        label: "ગુજરાતી",
        code: "gujarati"
    },
    {
        label: "മലയാളം",
        code: "malayalam"
    },

]

export const LANGUAGES_AXIS = [
    {
        label: "অসমীয়া",
        code: "assamese"
    },
    {
        label: "ଓଡିଆ",
        code: "oriya"
    },
    {
        label: "اردو",
        code: "urdu"
    },
    {
        label: "भोजपुरी",
        code: "bhojpuri"
    },
    {
        label: "मैथिली",
        code: "maithili"
    },
    // {
    //     label: "ꯃꯅꯤꯄꯨꯔꯤꯗꯥ ꯂꯩꯕꯥ꯫",
    //     code: "manipuri"
    // },
]